import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Loader from "../../components/Loader";
import CreateIcon from "@material-ui/icons/Create";
import { pink } from "@material-ui/core/colors";
import {
  Grid,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Box,
  Tooltip,
  Avatar,
  Typography,
  Divider,
} from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";

import Toaster from "../../components/Toaster";

import {
  USERS,
  ROLES,
  DRIVER_TYPES,
  USERNAME_UNIQUE_CHECK,
} from "../../configs/urls";
import {
  DRIVER_TYPES as DRIVER_TYPE,
  MARTIAL_STATUS,
  ROLES as USER_ROLES,
  KYC_TYPES,
  YES_NO,
  VACCINATION_STATUS,
  API_BASE_URL,
} from "../../configs/constant";

import axios from "axios";
import { getApi, postApi, putApi } from "../../services/api";
import useForm from "../../formValidator/userForm";
import { getLoggedInUserRole } from "../../services/localstorage";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "80%",
    margin: "auto",
  },
  formControl: {
    margin: theme.spacing(2, 0),
    minWidth: 200,
  },

  marginTop: {
    marginTop: "4%",
    width: "100%",
  },

  importButton: {
    padding: "30px 10px",
  },

  selectFullWidth: {
    margin: theme.spacing(2, 0),
    minWidth: "100%",
  },
  kycLabel: {
    margin: theme.spacing(2, 0),
    minWidth: 180,
  },

  pink: {
    color: theme.palette.getContrastText(pink[500]),
    backgroundColor: pink[500],
  },
  disable: {
    pointerEvents: "none",
    opacity: 0.5,
  },

  title: {
    padding: "9px 35px",
    borderRadius: "7px",
    color: "white",
    background: "#2b7b56",
  },
}));

export default function UserOperations(props) {
  const classes = useStyles();
  const [roles, setRoles] = useState([]);
  const [isUserAlreadyExist, setIsUserAlreadyExist] = useState(false);
  const [driverTypes, setDriverTypes] = useState([]);
  const [isRequesting, setIsRequesting] = useState(false);
  const [operationText, setOperationText] = useState("Add User");
  const [profilePicPreview, setProfilePicPreview] = useState();
  const [districtLists, setDistrictLists] = useState([]);
  const [stateList, setStateLists] = useState([]);
  const [villageList, setVillageLists] = useState([]);
  const [selectedDate, setDate] = useState();

  const firstRender = useRef(true);
  const userId = props?.match?.params?.user_id || "";
  const validate = (values) => {
    let errors = {};

    if (!values.name) {
      errors.name = "Name is required";
    }

    if (!values?.password && !props.match.params.user_id) {
      errors.password = "Password is required";
    }

    if (!values?.father_name) {
      errors.father_name = "Father's Name is required";
    }

    if (!values?.mother_name) {
      errors.mother_name = "Mother's Name is required";
    }

    if (!values?.dob) {
      errors.dob = "Date of Birth is required";
    }

    if (!values?.martial_status) {
      errors.martial_status = "Martial Status is required";
    }

    if (!values?.dependents) {
      errors.dependents = "Number of dependents is required";
    }

    if (!values?.address) {
      errors.address = "Address is required";
    }

    if (!values?.state_id) {
      errors.state_id = "State is required";
    }

    if (!values?.district_id) {
      errors.district_id = "City is required";
    }

    if (!values?.village_id) {
      errors.village_id = "Village is required";
    }

    if (!values?.pin_code) {
      errors.pin_code = "Pin Code is required";
    }

    if (!values?.username) {
      errors.username = "Username is required";
    }

    if (values?.username && values?.username.length < 4) {
      errors.username = "Username should be minimum of 3 characters";
    }

    if (isUserAlreadyExist) {
      errors.username = "Username already exist";
    }

    if (!values?.doc2_type) {
      errors.doc2_type = "Do you have Contract Copy?";
    }

    if (!values?.pf_account_number) {
      errors.pf_account_number = "EPF Number is required";
    }

    if (!values?.esi_number) {
      errors.esi_number = "E.S.I is required";
    }

    if (!values?.employee_id) {
      errors.employee_id = "Employee Id is required";
    }

    if (!values?.branch_address) {
      errors.branch_address = "Bank Address is required";
    }

    if (!values?.ifsc_code) {
      errors.ifsc_code = "Bank IFSC Code is required";
    }

    if (!values?.bank_name) {
      errors.bank_name = "Bank Name is required";
    }

    if (!values?.account_name) {
      errors.account_name = "Account Name is required";
    }

    if (!values?.account_number) {
      errors.account_number = "Bank Account Number is required";
    }

    // --- Not required: uncomment when it will be required
    // if (values.email && !/\S+@\S+\.\S+/.test(values.email)) {
    //   errors.email = "Email address is invalid";
    // }

    if (!values?.mobile_no) {
      errors.mobile_no = "Phone number is required";
    } else if (
      values.mobile_no.length < 10 ||
      !/^[0-9]/.test(values.mobile_no)
    ) {
      errors.mobile_no = "Phone number is not valid ";
    }

    // --- Not required: uncomment when it will be required
    // if (!values?.alternate_number) {
    //   errors.alternate_number = "Alternate number is required";
    // } else if (
    //   values.alternate_number.length < 10 ||
    //   !/^[0-9]/.test(values.alternate_number)
    // ) {
    //   errors.alternate_number = "Alternate number is not valid ";
    // }

    if (!values?.doc1_type) {
      errors.doc1_type = "Select your identity proof";
    }

    if (
      values?.doc1_type &&
      !values?.doc1_image &&
      !props.match.params.user_id
    ) {
      errors.doc1_image = "Identity Proof image required";
    }

    if (!values?.doc2_type) {
      errors.doc2_type = "Do you have Contract Copy";
    }

    if (
      values?.doc2_type &&
      values?.doc2_type == 1 &&
      !values?.doc2_image &&
      !props.match.params.user_id
    ) {
      errors.doc2_image = " Contract Copy required in jpeg format";
    }

    if (!values?.doc3_type) {
      errors.doc3_type = "Please select your Vaccination Status";
    }

    if (
      values?.doc3_type &&
      values?.doc3_type > 1 &&
      !values?.doc3_image &&
      !props.match.params.user_id
    ) {
      errors.doc3_image = "Vaccination certificate required in jpeg format";
    }

    if (!values?.doc4_type) {
      errors.doc4_type = "Do you have Driving License?";
    }

    if (
      values?.doc4_type &&
      values?.doc4_type == 1 &&
      !values?.license_number
    ) {
      errors.license_number = "Driving License Number is required";
    }

    if (
      values?.doc4_type &&
      values?.doc4_type == 1 &&
      values?.license_number &&
      !values?.doc4_image &&
      !props.match.params.user_id
    ) {
      errors.doc4_image = "Driving License required";
    }

    return errors;
  };

  /**
   * @description: Getting all the list of States
   */
  useEffect(() => {
    axios.get(`${API_BASE_URL}/states`).then(({ data }) => {
      setStateLists(data);
    });
  }, []);

  const saveUser = () => {
    setIsRequesting(true);
    let request = null;
    const formData = new FormData();

    for (const key in params) {
      formData.append(key, params[key]);
    }
    if (params.role_id != USER_ROLES.DRIVER) {
      formData.delete("driver_type_id");
    }

    if (props.match && props.match.params && props.match.params.user_id) {
      formData.append("id", props.match.params.user_id);
      request = putApi(USERS, formData);
    } else {
      request = postApi(USERS, formData);
    }
    request
      .then(
        (res) => {
          Toaster.showSuccess(res.message);
          props.history.push("/admin/users");
        },
        (err) => {
          Toaster.showError(err.message);
        }
      )
      .finally(() => {
        setIsRequesting(false);
      });
  };

  const { params, errors, handleChange, handleSubmit } = useForm(
    saveUser,
    validate
  );
  useEffect(() => {
    if (params.district_id) {
      handleStateClick(params.state_id)();
      handleVillageSelection(params.district_id)();
    }
  }, [params?.district_id]);

  useEffect(() => {
    setIsRequesting(true);

    const userRoles = getApi(ROLES);
    const getDriverTypes = getApi(DRIVER_TYPES);

    let user = null;

    if (props?.match?.params?.user_id) {
      user = getApi(USERS + "/" + props.match.params.user_id);
      setOperationText("Update User");
    }

    axios
      .all([userRoles, user, getDriverTypes])
      .then((res) => {
        if (res[0] && res[0].data) {
          setRoles(res[0].data);
          if (res[0].data[0]) params.role_id = res[0].data[0].id;
        }

        if (res[2] && res[2].data) {
          setDriverTypes(res[2].data);
          if (res[2].data[0]) params.driver_type_id = res[2].data[0].id;
        }

        if (res[1] && res[1].data) {
          const {
            username,
            password,
            name,
            father_name,
            mother_name,
            email,
            dob,
            mobile_no,
            dependents,
            martial_status,
            alternate_number,
            address,
            district_id,
            state_id,
            village_id,
            pin_code,
            license_number,
            bank_name,
            account_name,
            account_number,
            ifsc_code,
            branch_address,
            employee_id,
            pf_account_number,
            esi_number,
            doc2_type,
            doc1_type,
            doc3_type,
            doc4_type,
            doc2_image,
            doc1_image,
            doc3_image,
            doc4_image,
            role_id,
            driver_type_id,
            user_bank_details,
            user_employement_details,
            vaccination_status,
          } = res[1].data;
          params.password = password;
          params.username = username;
          params.name = name;
          params.father_name = father_name;
          params.mother_name = mother_name;
          params.email = email;
          params.martial_status = martial_status;
          params.dependents = dependents;
          params.dob = dob;

          params.address = address;
          params.district_id = district_id;
          params.state_id = state_id;
          params.pin_code = pin_code;
          params.village_id = village_id;

          params.mobile_no = mobile_no;
          params.alternate_number = alternate_number;

          params.license_number = license_number;

          params.account_name = user_bank_details?.account_name;
          params.bank_name = user_bank_details?.bank_name;
          params.account_number = user_bank_details?.account_number;
          params.ifsc_code = user_bank_details?.ifsc_code;
          params.branch_address = user_bank_details?.branch_address;

          params.pf_account_number =
            user_employement_details?.pf_account_number;
          params.esi_number = user_employement_details?.esi_number;
          params.employee_id = user_employement_details?.employee_id;

          params.doc1_type = doc1_type;
          params.doc2_type = doc2_type || "No";
          params.doc3_type = doc3_type;
          params.doc4_type = doc4_type || "No";
          params.doc1_image = doc1_image;
          params.doc2_image = doc2_image;
          params.doc3_image = doc3_image;
          params.doc4_image = doc4_image;
          params.role_id = role_id;
          params.driver_type_id = driver_type_id;
          params.role_slug = res[1].role.slug;
          params.vaccination_status = vaccination_status;
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsRequesting(false);
      });

    /**
     * Add cleanup code here
     */
    return function () {
      setIsRequesting(false);
    };
  }, []); //eslint-disable-line

  const handleUserNameChange = (e) => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    firstRender.current = false;
    const value = e.target.value;
    if (!value || value.length < 4) return;

    let params = {
      username: value || "",
    };

    if (props.match.params && props.match.params.user_id) {
      params.user_id = props.match.params.user_id;
    }

    postApi(USERNAME_UNIQUE_CHECK, params).then(
      () => {
        setIsUserAlreadyExist(false);
      },
      () => {
        setIsUserAlreadyExist(true);
      }
    );
  };

  const handleImageSelectionChange = (event, type) => {
    const file = event.target.files[0];
    if (type === "doc1_type") {
      params.doc1_image = file;
    }

    if (type === "doc2_type") {
      params.doc2_image = file;
    }

    if (type === "doc3_type") {
      params.doc3_image = file;
    }

    if (type === "doc4_type") {
      params.doc4_image = file;
    }

    if (type === "profile") {
      params.profile_pic = file;
      const objectUrl = URL.createObjectURL(file);
      setProfilePicPreview(objectUrl);
    }
  };

  /**
   * @description: selection of districts
   *
   * @param {Number} id
   * @returns
   */
  const handleDOB = (date, value) => {
    setDate(moment(new Date(date)).format("DD/MM/YYYY"));
    params.dob = moment(new Date(date)).format("DD/MM/YYYY");
  };

  /**
   * @description: selection of districts
   *
   * @param {Number} id
   * @returns
   */
  const handleStateClick = (id) => () => {
    setIsRequesting(true);
    try {
      if (!params.district_id || !id)
        axios
          .get(`${API_BASE_URL}/districts?state_id=${id}`)
          .then(({ data = [] }) => {
            setDistrictLists(data);
          });
    } catch (err) {
      console.error(err);
    } finally {
      setIsRequesting(false);
    }
  };

  /**
   * @description: selection of Villages
   *
   * @param {Number} id
   * @returns
   */
  const handleVillageSelection = (id) => () => {
    setIsRequesting(true);

    try {
      axios
        .get(`${API_BASE_URL}/villages?district_id=${id}`)
        .then(({ data }) => {
          setVillageLists(data);
        });
    } catch (error) {
    } finally {
      setIsRequesting(false);
    }
  };
  return (
    <div className={classes.root}>
      <Loader isLoading={isRequesting} />

      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <form noValidate onSubmit={handleSubmit} id="form">
            <Card>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>{operationText}</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={6} md={3}>
                    <Grid
                      container
                      direction="row"
                      justify="space-between"
                      alignItems="center"
                    >
                      <FormControl
                        variant="outlined"
                        className={`${classes.selectFullWidth} ${
                          props.match.params &&
                          props.match.params.user_id &&
                          getLoggedInUserRole() != "super_admin" &&
                          getLoggedInUserRole() != "admin"
                            ? classes.disable
                            : null
                        }`}
                      >
                        <InputLabel id="demo-simple-select-outlined-label">
                          Role
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          name="role_id"
                          value={params.role_id || USER_ROLES.DRIVER}
                          onChange={handleChange}
                          label="Role"
                        >
                          {roles.map((role, idx) => (
                            <MenuItem key={idx} value={role.id}>
                              {role.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {params.role_id == USER_ROLES.DRIVER && (
                        <FormControl
                          variant="outlined"
                          className={`${classes.selectFullWidth} ${
                            props.match.params &&
                            props.match.params.user_id &&
                            getLoggedInUserRole() != "super_admin" &&
                            getLoggedInUserRole() != "admin"
                              ? classes.disable
                              : null
                          }`}
                        >
                          <InputLabel id="demo-simple-select-outlined-label">
                            Type
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            name="driver_type_id"
                            value={
                              params.driver_type_id || DRIVER_TYPE.BAILER_DRIVER
                            }
                            onChange={handleChange}
                            label="Role"
                          >
                            {driverTypes.map((type, idx) => (
                              <MenuItem key={idx} value={type.id}>
                                {type.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}
                    </Grid>
                  </GridItem>
                  <GridItem xs={12} sm={6} md={3}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="username"
                      label="Username"
                      name="username"
                      autoFocus
                      inputProps={{
                        autoComplete: "new-username",
                      }}
                      value={params.username || ""}
                      onChange={(e) => {
                        handleChange(e);
                        handleUserNameChange(e);
                      }}
                    />
                    {isUserAlreadyExist ? (
                      <Box color="secondary.main">Username already used.</Box>
                    ) : (
                      errors?.username && (
                        <Box color="secondary.main">{errors?.username}</Box>
                      )
                    )}
                  </GridItem>

                  <GridItem xs={12} sm={6} md={3}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="password"
                      label="Password"
                      name="password"
                      type="password"
                      inputProps={{
                        autoComplete: "new-password",
                      }}
                      value={params.password || ""}
                      onChange={handleChange}
                    />
                    {errors?.password && (
                      <Box color="secondary.main">{errors?.password}</Box>
                    )}
                  </GridItem>

                  <GridItem xs={12} sm={6} md={3}>
                    <div style={{ position: "relative" }}>
                      <input
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        id="contained-button-file"
                        onChange={(e) =>
                          handleImageSelectionChange(e, "profile")
                        }
                      />
                      <label htmlFor="contained-button-file">
                        <Avatar
                          src={profilePicPreview}
                          border={2}
                          style={{
                            margin: "10px",
                            width: "70px",
                            height: "70px",
                          }}
                        />
                        <Tooltip
                          title="User's profile picture"
                          arrow
                          placement="right"
                          interactive
                        >
                          <Avatar
                            className={classes.pink}
                            style={{
                              position: "absolute",
                              bottom: 10,
                              marginLeft: 60,
                              width: "30px",
                              height: "30px",
                            }}
                          >
                            <CreateIcon
                              style={{
                                width: "20px",
                                height: "20px",
                              }}
                            />
                          </Avatar>
                        </Tooltip>
                      </label>
                    </div>
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="name"
                      label="Name"
                      name="name"
                      autoFocus
                      value={params.name || ""}
                      onChange={handleChange}
                    />
                    {errors?.name && (
                      <Box color="secondary.main">{errors?.name}</Box>
                    )}
                  </GridItem>

                  <GridItem xs={12} sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="father_name"
                      label="Father's Name"
                      name="father_name"
                      autoFocus
                      value={params.father_name || ""}
                      onChange={handleChange}
                    />
                    {errors?.father_name && (
                      <Box color="secondary.main">{errors?.father_name}</Box>
                    )}
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="mother_name"
                      label="Mother's Name"
                      name="mother_name"
                      autoFocus
                      value={params.mother_name || ""}
                      onChange={handleChange}
                    />
                    {errors?.mother_name && (
                      <Box color="secondary.main">{errors?.mother_name}</Box>
                    )}
                  </GridItem>

                  <GridItem xs={12} sm={12} md={6}>
                    <KeyboardDatePicker
                      autoOk
                      required
                      className={classes.marginTop}
                      variant="inline"
                      inputVariant="outlined"
                      label="Date Of Birth"
                      format="DD/MM/YYYY"
                      value={selectedDate || params?.dob}
                      inputValue={selectedDate || params?.dob}
                      name="dob"
                      InputAdornmentProps={{ position: "start" }}
                      onChange={handleDOB}
                    />
                    {errors?.dob && (
                      <Box color="secondary.main">{errors?.dob}</Box>
                    )}
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <FormControl
                      variant="outlined"
                      className={`${classes.selectFullWidth} `}
                    >
                      <InputLabel id="demo-simple-select-outlined-label">
                        Martial Status*
                      </InputLabel>
                      <Select
                        required
                        fullWidth
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        name="martial_status"
                        value={params?.martial_status || ""}
                        onChange={handleChange}
                        label="Martial Status*"
                      >
                        {Object.values(MARTIAL_STATUS).map(
                          ({ status, id, value }, idx) => {
                            return (
                              <MenuItem
                                key={idx + "-" + id + status}
                                value={value}
                              >
                                {status}
                              </MenuItem>
                            );
                          }
                        )}
                      </Select>
                    </FormControl>
                    {errors?.martial_status && (
                      <Box color="secondary.main">{errors?.martial_status}</Box>
                    )}
                  </GridItem>

                  <GridItem xs={12} sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="dependents"
                      label="No. of Dependents"
                      name="dependents"
                      inputProps={{ maxLength: 2 }}
                      value={params.dependents || ""}
                      onChange={handleChange}
                    />
                    {errors?.dependents && (
                      <Box color="secondary.main">{errors?.dependents}</Box>
                    )}
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="address"
                      label="Address"
                      name="address"
                      type="address"
                      inputProps={{
                        autoComplete: "Address",
                      }}
                      value={params.address || ""}
                      onChange={handleChange}
                    />
                    {errors?.address && (
                      <Box color="secondary.main">{errors?.address}</Box>
                    )}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <FormControl
                      variant="outlined"
                      className={classes.selectFullWidth}
                    >
                      <InputLabel id="demo-simple-select-outlined-label">
                        State*
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        name="state_id"
                        value={params.state_id || ""}
                        onChange={handleChange}
                        label="State*"
                        required
                        fullWidth
                      >
                        {stateList.map((states, idx) => {
                          const { id = "", name = "" } = states;
                          return (
                            <MenuItem
                              key={idx + "-" + name + "-" + id}
                              value={id}
                              onClick={handleStateClick(id)}
                            >
                              {name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <FormControl
                      variant="outlined"
                      className={classes.selectFullWidth}
                    >
                      <InputLabel id="demo-simple-select-outlined-label">
                        City*
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        name="district_id"
                        value={params.district_id || ""}
                        fullWidth
                        onChange={handleChange}
                        label="City*"
                        required
                        disabled={!params.state_id}
                      >
                        {districtLists.map((district, idx) => {
                          const { id = "", name = "", state_id = 1 } = district;
                          return (
                            <MenuItem
                              key={idx + "-" + name + "-" + state_id}
                              value={id}
                              onClick={handleVillageSelection(id)}
                            >
                              {name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    {errors?.district_id && (
                      <Box color="secondary.main">{errors?.district_id}</Box>
                    )}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <FormControl
                      variant="outlined"
                      className={classes.selectFullWidth}
                    >
                      <InputLabel id="demo-simple-select-outlined-label">
                        Village*
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-outlined-label"
                        id="village_id demo-simple-select-outlined"
                        name="village_id"
                        value={params.village_id || ""}
                        fullWidth
                        onChange={handleChange}
                        label="Village*"
                        required
                        disabled={!params.state_id && !params.district_id}
                      >
                        {villageList.map((village, idx) => {
                          const { id = "", name = "" } = village;
                          return (
                            <MenuItem key={idx + "-" + name + "-"} value={id}>
                              {name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    {errors?.village_id && (
                      <Box color="secondary.main">{errors?.village_id}</Box>
                    )}

                    {errors?.state_id && (
                      <Box color="secondary.main">{errors?.state_id}</Box>
                    )}
                  </GridItem>

                  <GridItem xs={12} sm={12} md={3}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      className={classes.selectFullWidth}
                      required
                      fullWidth
                      id="pin_code"
                      label="Pin code"
                      name="pin_code"
                      inputProps={{ maxLength: 6 }}
                      value={params.pin_code || ""}
                      onChange={handleChange}
                    />
                    {errors?.pin_code && (
                      <Box color="secondary.main">{errors?.pin_code}</Box>
                    )}
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="mobile_no"
                      label="Phone Number"
                      name="mobile_no"
                      inputProps={{ maxLength: 10 }}
                      value={params.mobile_no || ""}
                      onChange={handleChange}
                    />
                    {errors?.mobile_no && (
                      <Box color="secondary.main">{errors?.mobile_no}</Box>
                    )}
                  </GridItem>

                  <GridItem xs={12} sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      id="alternate_number"
                      label="Alternate Phone Number"
                      name="alternate_number"
                      inputProps={{ maxLength: 10 }}
                      value={params.alternate_number || ""}
                      onChange={handleChange}
                    />
                    {errors?.alternate_number && (
                      <Box color="secondary.main">
                        {errors?.alternate_number}
                      </Box>
                    )}
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      id="email"
                      label="Email"
                      name="email"
                      value={params.email || ""}
                      onChange={handleChange}
                      inputProps={{
                        autoComplete: "new-email",
                      }}
                    />
                    {errors?.email && (
                      <Box color="secondary.main">{errors?.email}</Box>
                    )}
                  </GridItem>
                  <GridItem xs={6} md={3}>
                    <FormControl
                      variant="outlined"
                      className={classes.selectFullWidth}
                    >
                      <InputLabel id="demo-simple-select-outlined-label">
                        Identity Proof*
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        name="doc1_type"
                        value={
                          KYC_TYPES[params?.doc1_type]?.id
                            ? KYC_TYPES[params?.doc1_type].id
                            : ""
                        }
                        onChange={handleChange}
                        label="Identity Proof"
                      >
                        {KYC_TYPES.map((type, idx) => (
                          <MenuItem key={idx} value={type.id}>
                            {type.value}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {errors?.doc1_type && (
                      <Box color="secondary.main">{errors?.doc1_type}</Box>
                    )}
                  </GridItem>

                  <GridItem xs={4} md={3}>
                    <input
                      disabled={!params?.doc1_type}
                      className={classes.importButton}
                      type="file"
                      accept="image/*"
                      onChange={(e) =>
                        handleImageSelectionChange(e, "doc1_type")
                      }
                    />
                    {errors?.doc1_image && (
                      <Box color="secondary.main">{errors?.doc1_image}</Box>
                    )}
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <Grid container>
                      <Grid item xs={6} md={6}>
                        <FormControl
                          variant="outlined"
                          className={classes.selectFullWidth}
                        >
                          <InputLabel id="demo-simple-select-outlined-label">
                            Contract Copy*
                          </InputLabel>

                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            name="doc2_type"
                            value={params?.doc2_type || ""}
                            onChange={handleChange}
                            label="Contract Copy"
                          >
                            {Object.values(YES_NO).map(
                              ({ label, value, id }, idx) => {
                                return (
                                  <MenuItem
                                    key={idx + "-" + id + "-" + value}
                                    value={id}
                                  >
                                    {label}
                                  </MenuItem>
                                );
                              }
                            )}
                          </Select>
                        </FormControl>
                        {errors?.doc2_type && (
                          <Box color="secondary.main">{errors?.doc2_type}</Box>
                        )}
                      </Grid>
                      <Grid item xs={4} md={4} style={{ padding: 30 }}>
                        <input
                          type="file"
                          accept="image/*"
                          disabled={
                            !params?.doc2_type || params?.doc2_type == 2
                          }
                          required
                          onChange={(e) =>
                            handleImageSelectionChange(e, "doc2_type")
                          }
                        />
                        {errors?.doc2_image && (
                          <Box color="secondary.main">{errors?.doc2_image}</Box>
                        )}
                      </Grid>
                    </Grid>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <Grid container>
                      <Grid item xs={6} md={6}>
                        <FormControl
                          variant="outlined"
                          className={classes.selectFullWidth}
                        >
                          <InputLabel id="demo-simple-select-outlined-label">
                            Vaccination Status*
                          </InputLabel>
                          <Select
                            required
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            name="doc3_type"
                            value={
                              params?.vaccination_status ||
                              params?.doc3_type ||
                              ""
                            }
                            onChange={handleChange}
                            label="Vaccination Status"
                          >
                            {Object.values(VACCINATION_STATUS).map(
                              ({ id = 0, value = "", label = "" }, idx) => (
                                <MenuItem
                                  key={idx + "-" + value + "-" + id}
                                  value={id}
                                >
                                  {label}
                                </MenuItem>
                              )
                            )}
                          </Select>
                        </FormControl>
                        {errors?.doc3_type && (
                          <Box color="secondary.main">{errors?.doc3_type}</Box>
                        )}
                      </Grid>
                      <Grid item xs={4} md={4} style={{ padding: 30 }}>
                        <input
                          required
                          type="file"
                          disabled={
                            !params?.doc3_type || params?.doc3_type == 1
                          }
                          accept="image/*"
                          onChange={(e) =>
                            handleImageSelectionChange(e, "doc3_type")
                          }
                        />
                        {errors?.doc3_image && (
                          <Box color="secondary.main">{errors?.doc3_image}</Box>
                        )}
                      </Grid>
                    </Grid>
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={6} md={3}>
                    <FormControl
                      variant="outlined"
                      className={`${classes.selectFullWidth} `}
                    >
                      <InputLabel id="demo-simple-select-outlined-label">
                        Driving License (Yes/No)*
                      </InputLabel>
                      <Select
                        fullWidth
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        name="doc4_type"
                        value={params.doc4_type || ""}
                        onChange={handleChange}
                        label="Driving License (Yes/No)*"
                      >
                        {Object.values(YES_NO).map(
                          ({ label, value, id }, idx) => {
                            return (
                              <MenuItem
                                key={idx + "-" + id + "-" + value}
                                value={id}
                              >
                                {label}
                              </MenuItem>
                            );
                          }
                        )}
                      </Select>
                    </FormControl>
                    {errors?.doc4_type && (
                      <Box color="secondary.main">{errors?.doc4_type}</Box>
                    )}
                  </GridItem>

                  <GridItem xs={12} sm={6} md={3}>
                    <TextField
                      required
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      disabled={!params?.doc4_type || params.doc4_type == 2}
                      id="license_number"
                      label="Enter Driving License Number "
                      name="license_number"
                      value={params.license_number || ""}
                      onChange={handleChange}
                    />
                    {errors?.license_number && (
                      <Box color="secondary.main">{errors?.license_number}</Box>
                    )}
                  </GridItem>

                  <GridItem xs={12} sm={12} md={6}>
                    <Grid container>
                      <Grid item xs={6} md={6}>
                        <FormControl
                          variant="outlined"
                          className={classes.kycLabel}
                        >
                          <InputLabel id="demo-simple-select-outlined-label">
                            Upload Driving License*
                          </InputLabel>
                        </FormControl>
                      </Grid>
                      <Grid item xs={4} md={4} style={{ padding: 30 }}>
                        <input
                          disabled={
                            !params?.doc4_type ||
                            params?.doc4_type == 2 ||
                            !params?.license_number
                          }
                          type="file"
                          accept="image/*"
                          onChange={(e) =>
                            handleImageSelectionChange(e, "doc4_type")
                          }
                        />
                        {errors?.doc4_image && (
                          <Box color="secondary.main">{errors?.doc4_image}</Box>
                        )}
                      </Grid>
                    </Grid>
                  </GridItem>
                </GridContainer>

                {/* ----Horizontal Line---- */}
                <Divider style={{ margin: "2%" }} />

                {/* ----Bank detail Title---- */}
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography variant="h6" className={classes.title}>
                      Bank Account Details
                    </Typography>
                  </GridItem>
                </GridContainer>

                {/* ----Bank detail form---- */}
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12} lg={6} xl={6}>
                    {/* --- Bank Name -- */}
                    <TextField
                      variant="outlined"
                      required
                      margin="normal"
                      fullWidth
                      id="bank_name"
                      label="Bank Name "
                      name="bank_name"
                      value={params.bank_name || ""}
                      onChange={handleChange}
                    />
                    {errors?.bank_name && (
                      <Box color="secondary.main">{errors?.bank_name}</Box>
                    )}
                  </GridItem>

                  <GridItem xs={12} sm={12} md={12} lg={6} xl={6}>
                    {/* --- Account Name -- */}
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="account_name"
                      label="Account Name "
                      name="account_name"
                      value={params.account_name || ""}
                      onChange={handleChange}
                    />
                    {errors?.account_name && (
                      <Box color="secondary.main">{errors?.account_name}</Box>
                    )}
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={12} lg={6} xl={6}>
                    {/* --- Account Number -- */}
                    <TextField
                      variant="outlined"
                      required
                      margin="normal"
                      fullWidth
                      id="account_number"
                      label="Account Number"
                      name="account_number"
                      value={params.account_number || ""}
                      onChange={handleChange}
                    />
                    {errors?.account_number && (
                      <Box color="secondary.main">{errors?.account_number}</Box>
                    )}
                  </GridItem>

                  <GridItem xs={12} sm={12} md={12} lg={6} xl={6}>
                    {/* --- IFSC Code -- */}
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required
                      fullWidth
                      id="ifsc_code"
                      label="IFSC Code"
                      name="ifsc_code"
                      value={params.ifsc_code || ""}
                      onChange={handleChange}
                    />
                    {errors?.ifsc_code && (
                      <Box color="secondary.main">{errors?.ifsc_code}</Box>
                    )}
                  </GridItem>

                  <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
                    {/* --- Address -- */}
                    <TextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      id="branch_address"
                      label="Branch Address"
                      name="branch_address"
                      required
                      value={params.branch_address || ""}
                      onChange={handleChange}
                    />
                    {errors?.branch_address && (
                      <Box color="secondary.main">{errors?.branch_address}</Box>
                    )}
                  </GridItem>
                </GridContainer>

                {/* ----Horizontal Line---- */}
                <Divider style={{ margin: "2%" }} />

                {/* ----Employment detail Title---- */}
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography variant="h6" className={classes.title}>
                      Employment Details
                    </Typography>
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={12} lg={6} xl={6}>
                    {/* --- Employee Id -- */}
                    <TextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      id="employee_id"
                      required
                      label="Employee ID"
                      name="employee_id"
                      value={params.employee_id || ""}
                      inputProps={{ maxLength: 6 }}
                      onChange={handleChange}
                    />
                    {errors?.employee_id && (
                      <Box color="secondary.main">{errors?.employee_id}</Box>
                    )}
                  </GridItem>

                  <GridItem xs={12} sm={12} md={12} lg={6} xl={6}>
                    {/* --- ESI number -- */}
                    <TextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      id="esi_number"
                      label="E.S.I. Number"
                      required
                      name="esi_number"
                      value={params.esi_number || ""}
                      onChange={handleChange}
                    />
                    {errors?.esi_number && (
                      <Box color="secondary.main">{errors?.esi_number}</Box>
                    )}
                  </GridItem>

                  <GridItem xs={12} sm={12} md={12} lg={6} xl={6}>
                    {/* --- PF account number -- */}
                    <TextField
                      variant="outlined"
                      margin="normal"
                      fullWidth
                      id="pf_account_number"
                      required
                      label="Provident Account Number"
                      name="pf_account_number"
                      value={params.pf_account_number || ""}
                      onChange={handleChange}
                    />
                    {errors?.pf_account_number && (
                      <Box color="secondary.main">
                        {errors?.pf_account_number}
                      </Box>
                    )}
                  </GridItem>
                </GridContainer>
              </CardBody>
              <CardFooter>
                <Grid
                  container
                  direction="row"
                  justify="flex-end"
                  alignItems="center"
                >
                  <Button color="primary" type="submit">
                    {operationText}
                  </Button>
                </Grid>
              </CardFooter>
            </Card>
          </form>
        </GridItem>
      </GridContainer>
    </div>
  );
}
